// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3Q2SE","detailsBorder":"styles_detailsBorder__2l8Lz"};